import { U2bColumnDefinitionBrakePoint } from '@core/components/layout/table/table.types';

export function getIsActive(mobile = true, tablet = true, desktop = true): { [key in U2bColumnDefinitionBrakePoint]: boolean } {
    return {
        [U2bColumnDefinitionBrakePoint.Mobile]: desktop,
        [U2bColumnDefinitionBrakePoint.Tablet]: tablet,
        [U2bColumnDefinitionBrakePoint.Desktop]: mobile
    };
}
